import WebLocationService from "../services/LocationService";

export const getLatLong = async () => {
  try {
    const { latitude, longitude } = await WebLocationService.getLocation();
    return {
      latitude,
      longitude,
    };
  } catch (err) {
    try {
      const data = await WebLocationService.ipBasedLocation();
      const { lat, lon } = data;
      return {
        latitude: lat,
        longitude: lon,
      };
    } catch (err) {
      console.error(err);
    }
  }
};
